import {Helmet} from 'react-helmet-async';
import '../components/InformationPage.css';

function DisclaimerPage() {
  return (
    <>
      <Helmet>
        <title>Medical Coding Education Disclaimer | Medical Coding Classes Online</title>
        <meta
          name="description"
          content="Read the editorial, educational, and medical disclaimer for Medical Coding Classes Online, an independent study platform."
        />
        <link rel="canonical" href="https://medicalcodingclassesonline.com/disclaimer" />
      </Helmet>
      <main className="information-page">
        <section className="information-hero">
          <div className="container">
            <span className="eyebrow">Important information</span>
            <h1>Educational and editorial disclaimer</h1>
            <p>
              Please review the following information before relying on any lesson, quiz,
              calculator, or reference tool.
            </p>
          </div>
        </section>
        <section className="information-section">
          <div className="container information-layout">
            <article className="information-content">
              <h2>Independent educational platform</h2>
              <p>
                Medical Coding Classes Online is an independent educational study platform built
                and owned by Leadsurance. It provides foundational information for aspiring
                medical billers, medical coders, and other learners exploring healthcare
                administrative careers.
              </p>
              <h2>Not a certifying organization</h2>
              <p>
                Medical Coding Classes Online is not an official partner, sponsor, affiliate, or
                endorsement of the American Academy of Professional Coders (AAPC), the American
                Health Information Management Association (AHIMA), or any other certifying body,
                professional association, college, university, employer, or government agency.
              </p>
              <p>
                References to AAPC, AHIMA, CPT, ICD-10-CM, HCPCS, CMS, or other organizations, code
                sets, and standards are provided for educational context only. All trademarks and
                names belong to their respective owners.
              </p>
              <h2>Not medical, legal, or professional advice</h2>
              <p>
                The content is not medical advice, diagnosis, treatment guidance, legal advice,
                compliance advice, payer advice, or a substitute for professional training. The
                platform does not tell users how to treat patients, make clinical decisions, submit
                actual claims, or interpret a specific patient record.
              </p>
              <h2>Verify current information</h2>
              <p>
                Coding systems, official guidelines, payer policies, regulations, and certification
                requirements may change. Examples, explanations, calculators, quizzes, and
                flashcards may simplify concepts for study. Always verify current requirements
                using official publications, current code books, payer guidance, employer policies,
                and qualified professional instruction before applying information in practice.
              </p>
              <h2>No guarantee of outcomes</h2>
              <p>
                Use of this platform does not guarantee certification exam results, employment,
                compensation, academic credit, professional competence, or acceptance into any
                educational program. Learners are responsible for choosing the education,
                references, and preparation that fit their goals.
              </p>
              <h2>Questions and corrections</h2>
              <p>
                If you identify an outdated statement, broken reference, or potential content
                issue, please contact{' '}
                <a href="mailto:support@leadsurance.com">support@leadsurance.com</a>.
              </p>
            </article>
            <aside className="information-aside">
              <span className="aside-label">Remember</span>
              <h2>Study aid, not official guidance</h2>
              <p>
                Use this site to build foundational understanding, then confirm every professional
                decision with current authoritative sources.
              </p>
            </aside>
          </div>
        </section>
      </main>
    </>
  );
}

export default DisclaimerPage;